import React from "react";
import { FaUserAlt, FaHotel, FaMapMarkedAlt } from "react-icons/fa";

const styles = {
    container: {
        width: "100%",
        maxWidth: "600px",
        margin: "0 auto 40px",
    },
    selectorContainer: {
        display: "flex",
        gap: "20px",
        marginTop: "16px",
    },
    roleCard: {
        flex: 1,
        padding: "24px 16px",
        borderRadius: "20px",
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        color: "#64748b",
        position: "relative",
    },
    roleCardActive: {
        borderColor: "#3b82f6",
        backgroundColor: "#eff6ff",
        color: "#3b82f6",
        transform: "translateY(-4px)",
        boxShadow: "0 15px 30px -10px rgba(59, 130, 246, 0.2)",
    },
    icon: {
        fontSize: "28px",
        marginBottom: "12px",
        transition: "all 0.3s ease",
    },
    label: {
        fontWeight: "700",
        fontSize: "14px",
        margin: 0,
        letterSpacing: "0.02em",
    }
};

function RoleSelector({ role, setRole }) {
    const roles = [
        { id: "Traveler", icon: <FaUserAlt />, label: "Traveler" },
        { id: "Hotel Owner", icon: <FaHotel />, label: "Hotel Owner" },
        { id: "Guide", icon: <FaMapMarkedAlt />, label: "Guide" }
    ];

    return (
        <div style={styles.container}>
            <p style={{ 
                textAlign: "center", 
                fontWeight: "700", 
                color: "#1e293b", 
                marginBottom: "20px",
                fontSize: "16px",
                textTransform: "uppercase",
                letterSpacing: "0.05em"
            }}>
                Identify Your Role
            </p>
            
            <div style={styles.selectorContainer}>
                {roles.map((r) => (
                    <div
                        key={r.id}
                        style={{
                            ...styles.roleCard,
                            ...(role === r.id ? styles.roleCardActive : {})
                        }}
                        onClick={() => setRole(r.id)}
                        onMouseEnter={(e) => {
                            if (role !== r.id) {
                                e.currentTarget.style.borderColor = "#3b82f6";
                                e.currentTarget.style.backgroundColor = "#f8fafc";
                                e.currentTarget.style.color = "#3b82f6";
                                e.currentTarget.style.transform = "translateY(-2px)";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (role !== r.id) {
                                e.currentTarget.style.borderColor = "#e2e8f0";
                                e.currentTarget.style.backgroundColor = "#ffffff";
                                e.currentTarget.style.color = "#64748b";
                                e.currentTarget.style.transform = "translateY(0)";
                            }
                        }}
                    >
                        <div style={{
                            ...styles.icon,
                            color: role === r.id ? "#3b82f6" : "inherit"
                        }}>
                            {r.icon}
                        </div>
                        <p style={styles.label}>{r.label}</p>
                        {role === r.id && (
                            <div style={{
                                position: "absolute",
                                bottom: "8px",
                                width: "6px",
                                height: "6px",
                                borderRadius: "50%",
                                backgroundColor: "#3b82f6"
                            }} />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default RoleSelector;